import React, { ReactElement } from 'react';

type Props = {
  className?: string;
  inputClass?: string;
  name: string;
  value: string | number;
  type?: string;
  autoComplete?: string;
  label?: string;
  placeholder?: string;
  bold?: boolean;
  prefix?: ReactElement;
  suffix?: ReactElement;
  disabled?: boolean;
  maxLength?: number;
  textSize?: string;
  onChange: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
onFocus?: (event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onEnter?: () => void;
  onKeyUp?: (
    e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  onKeyDown?: (
    e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  error?: boolean;
  require?: boolean;
  rows?: number;
  max?: number;
  min?: number;
  readOnly?: boolean;
  noBorder?: boolean;
  inputRef?: any;
  inputPadding?: string;
};

export function TextField({
  className = '',
  inputClass = '',
  name,
  value,
  type = 'text',
  autoComplete,
  label,
  placeholder,
  prefix,
  suffix,
  bold,
  disabled = false,
  maxLength,
  textSize = '',
  onChange,
  onBlur,
  onFocus,
  onEnter,
  onKeyUp,
  onKeyDown,
  error,
  require,
  rows,
  max,
  min,
  readOnly = false,
  noBorder,
  inputRef,
  inputPadding = 'p-2.5',
}: Props) {
  const isTextArea = type === 'textarea';
  const Input = isTextArea ? 'textarea' : 'input';

  const handleKeyUp = (
    e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    onKeyUp && onKeyUp(e);
    if (e.key === 'Enter' && onEnter && !isTextArea) {
      onEnter();
    }
  };

  return (
    <>
      {label && (
        <label
          htmlFor={name}
          className={`mb-2 block leading-6 ${
            bold ? 'font-bold' : 'font-medium'
          } ${textSize} ${error ? 'text-error' : 'text-neutral-600'}
					${disabled ? 'opacity-50' : ''}`}
        >
          {label}
          {require && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <div
        className={`${className}
				${disabled ? 'opacity-50' : ''}
				 flex items-center rounded-lg
         ${
           noBorder
             ? 'ring-0 focus:ring-0'
             : 'ring-1 focus-within:ring-2 focus-within:ring-primary'
         }
				 ${error ? `ring-error` : `ring-neutral-300`} 
         ${!isTextArea && (prefix || suffix) ? 'pr-2' : ''}`}
      >
        {!isTextArea && prefix}
        <Input
          type={type}
          name={name}
          id={name}
          autoComplete={autoComplete}
          className={` ${textSize} ${inputClass} ${inputPadding} block w-full border-0 bg-transparent placeholder:text-neutral-300 ring-0 focus:ring-0`}
          placeholder={placeholder}
          onChange={onChange}
          onBlur={onBlur}
          onFocus={onFocus}
          value={value}
          disabled={disabled}
          maxLength={maxLength}
          onKeyUp={handleKeyUp}
          onKeyDown={onKeyDown}
          rows={rows}
          max={max}
          min={min}
          readOnly={readOnly}
          ref={inputRef}
        />
        {!isTextArea && suffix}
      </div>
    </>
  );
}
